var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCotizacionDiferido(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.16,10.09a2.48,2.48,0,0,0-2.5-2.46h-.31V6.51a2.47,2.47,0,0,0-.74-1.75,2.44,2.44,0,0,0-1.75-.71l-16.6.1A2.48,2.48,0,0,0,.79,6.64V8.5h0l0,7.41a2.47,2.47,0,0,0,.74,1.74,2.43,2.43,0,0,0,1.74.72h.33v1.12A2.48,2.48,0,0,0,6.14,22h0l16.6-.1a2.51,2.51,0,0,0,1.75-.74,2.44,2.44,0,0,0,.71-1.75ZM22.67,8.88h0a1.24,1.24,0,0,1,1.23,1.22v1.22H22.37l0-2.44ZM3.26,5.4l16.6-.1h0a1.21,1.21,0,0,1,1.23,1.22V7.74L2,7.86V6.64A1.23,1.23,0,0,1,3.26,5.4Zm.07,11.72h0a1.2,1.2,0,0,1-.86-.36,1.17,1.17,0,0,1-.37-.86l0-6.79L21.11,9l0,6.79A1.23,1.23,0,0,1,19.93,17Zm20.28,3.11a1.19,1.19,0,0,1-.87.37l-16.6.1h0a1.22,1.22,0,0,1-1.23-1.22V18.36l15-.1a2.48,2.48,0,0,0,2.47-2.49l0-3.2h1.54l0,6.79A1.18,1.18,0,0,1,23.61,20.23Z",
    fill: "#3b444e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19,10.54H16.18a.63.63,0,0,0-.62.63.63.63,0,0,0,.63.62H19a.64.64,0,0,0,.62-.63A.62.62,0,0,0,19,10.54Z",
    fill: "#3b444e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.63,10.59h0l-7.41,0a.63.63,0,0,0-.62.63.64.64,0,0,0,.63.62h0l7.41,0a.63.63,0,0,0,.62-.63A.62.62,0,0,0,11.63,10.59Z",
    fill: "#3b444e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7,12.47H4.23a.63.63,0,1,0,0,1.25H7a.63.63,0,0,0,.62-.63A.62.62,0,0,0,7,12.47Z",
    fill: "#3b444e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCotizacionDiferido);
export default __webpack_public_path__ + "static/media/ic_cotizacion_diferido.a7f3c963f5bc1191cf7619d80f767a0c.svg";
export { ForwardRef as ReactComponent };